import styled from 'styled-components'

import { media } from '../../../styles/breakpoints'

export const MainPanelWrapper = styled.div`
  display: flex;
  justifuy-content: center;
  align-items: center;
  flex-grow: 0;
  height: 32px;
  overflow: hidden;

  @media ${media.belowTablet} {
    height: 44px;
    min-width: 44px;
  }
`
MainPanelWrapper.displayName = 'MainPanelWrapper'
